import L from 'leaflet';
import 'leaflet-rotatedmarker';
import HttpService from '../../providers/http-service.js';
import MarkerPopup from '../popup/marker-popup.js';
import { getConfig } from '../../config';

var AlternativeScale1 = 0.8;
var AlternativeTooltipOffsetY = 50;

class FortMarker extends L.Marker {
    constructor(object, map, scale) {
        super();
        this.map = map;
        this.clickable = true;
        this.object = object;
        this.name = object.name;
        this.config = getConfig();
        this.scale = scale;
        this.status = object.status;
        this.maxObjectLabelLength = this.config.marker.characters;
        this.httpService = new HttpService();
        this.path = '../../../../icons/objects/';
        this._latlng = this._getMarkerPosition(object.lat, object.lon);
        this.popup = null;
        this.options.icon = this._getObjectIcon(object);
        if (object.obj_icon_rotate && this.map.options.showObjectIconDirection !== true) {
            this.setIconAngle(object.direction);
        }
        this.labelMarkup = this._getObjectLabelMarkup();
        this.tooltip = null;
        this.hasDefaultRoute = typeof object.routeColor === 'string';
        this.selected = object.selected === true;

        document.addEventListener('map:toggleObjectsNamesVisibility', this.nameVisibilityCallback);
        document.addEventListener('map:newRoutePainted', this.routePaintedCallback);
        document.addEventListener('map:routeRemoved', this.routeRemovedCallback);
        document.addEventListener('map:objectSelected', this.objectSelectedCallback);

        const selectedColor = object.selected ? 'selected' : undefined;
        const tooltipColor = object.routeColor || selectedColor;
        this.setTooltip(tooltipColor);

        this.on('mouseover', this._onOverMarker);
        this.on('mouseout', this._onOutMarker);
        this.on('click', (event) => !this.map.isClickBlocked() &&
            this.clickable &&
            this._onClickMarker(event));
    }

    updateMarker(objectProps) {
        this._updatePosition(objectProps.lat, objectProps.lon);
        this._updateIcon(objectProps);
        this._updateLabel(objectProps);
        if (this.object.obj_icon_rotate && this.map.options.showObjectIconDirection !== true) {
            this.setIconAngle(objectProps.dir || objectProps.direction);
        }
    }

    _updatePosition(lat, lon) {
        let newLatLng = this._getMarkerPosition(lat, lon);
        this.setLatLng(newLatLng);
    }

    _updateIcon(objectProps) {
        this.object.status = objectProps.st;
        this.status = objectProps.st;
        let newObjectIcon = this._getObjectIcon(objectProps);
        this.setIcon(newObjectIcon);
    }

    _updateLabel(objectProps) {
        this.object.move = objectProps.move;
        this.object.ign = objectProps.ign;
        this.updateLabelMarkup();
    }

    updateLabelMarkup() {
        this.labelMarkup = this._getObjectLabelMarkup(this.object);
        this.setTooltipContent(this.labelMarkup.standartLabel);
    }

    _truncateLabel(label) {
        if (label.length > this.maxObjectLabelLength) {
            label = label.substring(0, this.maxObjectLabelLength - 4) + '..' + label.substring(label.length - 2);
        }
        return label;
    }

    getObjectStatus(status) {
        return fmtools.getStatusEventIcon(status);
    }

    _getObjectNameMarkup(visible, short = false) {
        if (!visible) {
            return '';
        }

        const nameText = short ? this._truncateLabel(this.name) : this.name;

        return `
            <span class="leaflet-label leaflet-label-inner">
                ${nameText}
            </span>
        `;
    }

    _getObjectLabelMarkup() {
        let imageStatusMarkup = this._getImageStatusMarkup(this.object.move);
        let ignIcon = this._getIgnitionIcon(this.object.ign);
        let fullLabel = `
            <div class="tooltip-container ${this.scale < 1 ? 'small-tooltip' : ''}">
                ${imageStatusMarkup}
                ${ignIcon}
                ${this._getObjectNameMarkup(this.map.options.showObjectsNames)}
            </div>
        `;
        let standartLabel = `
            <div class="tooltip-container ${this.scale < 1 ? 'small-tooltip' : ''}">
                ${imageStatusMarkup}
                ${ignIcon}
                ${this._getObjectNameMarkup(this.map.options.showObjectsNames, true)}
            </div>
        `;
        return {
            standartLabel: standartLabel,
            fullLabel: fullLabel
        };
    }

    _getObjectIcon(objectProps) {
        let iconUrl = this.path;
        let iconName = 'car_new.png';
        if (this.object.obj_icon == 'car.png' || this.object.obj_icon == '') {
            this.object.obj_icon = 'car_new.png';
            this.object.obj_icon_width = 50;
            this.object.obj_icon_height = 50;
        }
        else if (this.object.obj_icon == 'arrow.png') {
            this.object.obj_icon = 'arrow_new.png';
            this.object.obj_icon_width = 50;
            this.object.obj_icon_height = 50;
        }
        else if (this.object.obj_icon == 'arrow2.png') {
            this.object.obj_icon = 'arrow2_new.png';
            this.object.obj_icon_width = 50;
            this.object.obj_icon_height = 50;
        }
        else if (this.object.obj_icon == 'trk.png') {
            this.object.obj_icon = 'trk_new.png';
            this.object.obj_icon_width = 50;
            this.object.obj_icon_height = 50;
        }
        else if (this.object.obj_icon == 'benz.png' || this.object.obj_icon == 'trlr.png') {
            this.object.obj_icon = 'truck.png';
            this.object.obj_icon_width = 50;
            this.object.obj_icon_height = 50;
        }

        if (this.object.obj_ico_colored) {
            let fileName = this.object.obj_icon.split('.');
            if (fileName[0] == 'car')
                fileName[0] = 'car_new';
            if (fileName.length == 2) {
                switch (this.object.status) {
                    case 1: iconName = 'color/' + fileName[0] + '_red.' + fileName[1]; break;
                    case 2: iconName = 'color/' + fileName[0] + '_orange.' + fileName[1]; break;
                    case 3: iconName = 'color/' + fileName[0] + '_yellow.' + fileName[1]; break;
                    case 4: iconName = 'color/' + fileName[0] + '_blue.' + fileName[1]; break;
                    case 5: iconName = 'color/' + fileName[0] + '_green.' + fileName[1]; break;
                    default: iconName = 'color/' + fileName[0] + '_green.' + fileName[1]; break;
                }
            }
        }
        else {
            iconName = this.object.obj_icon;
        }

        if (iconName == '') {
            iconName = 'car_new.png';
        }

        iconUrl = iconUrl + iconName;

        if (this.map.options.showObjectIconDirection) {
            var size = 55;
            var angle = -90;
            var iconAngle = -angle;

            var direction = objectProps.dir;
            if (typeof direction != 'number') {
                direction = parseInt(objectProps.direction);
            }
            angle += direction;
            if (!this.object.obj_icon_rotate) {
                iconAngle -= direction;
            }
            
            var eventLevel = objectProps.st || objectProps.status;
            var color = 'green';
            var backgroundColor = '#00800040';
            switch (eventLevel) {
                case 1: color = '#f54337'; backgroundColor = '#f5433780'; break;
                case 2: color = '#fec107'; backgroundColor = '#fec10740'; break;
                case 3: color = '#909090'; backgroundColor = '#90909040'; break;
                case 4: color = '#2095f2'; backgroundColor = '#2095f240'; break;
            }

            var min = Math.min(this.object.obj_icon_width, this.object.obj_icon_height);
            if (min > 30) {
                size = 75;
            }

            var scale = this.scale;
            if (this.scale == 1) {
                scale = AlternativeScale1;
            }
            size *= scale;
            var imgWidth = this._getIconWidth(this.object.obj_icon_width) * scale;
            var imgHeight = this._getIconHeight(this.object.obj_icon_height) * scale;

            var divIcon = L.divIcon({
                html: '<div style="width:' + size + 'px;height:' + size + 'px;border-radius: 50%;transform: rotate(' + angle + 'deg);border: 2px solid ' + color + ';display: flex;justify-content: center;align-items: center;">'
                        + '<div class="object-icon-direction" style="background-color: ' + color + '"></div>'
                            + '<div style="width: 100%;height: 100%;background-color: ' + backgroundColor + ';border-radius: 50%;display:flex;align-items:center;justify-content:center;">'
                            + '<img style="width: ' + imgWidth + 'px;height: ' + imgHeight + 'px;transform: rotate(' + iconAngle + 'deg);"' + 'src="' + iconUrl + '" />'
                        + '</div>'
                    + '</div>',
                className: 'rotatable-object-icon',
                iconAnchor: [
                    this._getIconWidth(size) / 2,
                    this._getIconHeight(size) / 2
                ],
                iconSize: [0, 0]
            });

            if (this._tooltip) {
                this._tooltip.options.offset.y = AlternativeTooltipOffsetY * scale
            }
            return divIcon;
        };

        let icon = L.icon({
            iconUrl: iconUrl,
            iconAnchor: [
                this._getIconWidth(this.object.obj_icon_width) * this.scale / 2,
                this._getIconHeight(this.object.obj_icon_height) * this.scale / 2
            ],
            iconSize: [
                this._getIconWidth(this.object.obj_icon_width) * this.scale,
                this._getIconHeight(this.object.obj_icon_height) * this.scale
            ]
        })

        icon._createImg = (src, el) => {
            el = el || document.createElement('img');
            el.src = src;
            el.onerror = (event) => {
                el.src = '../../../../icons/objects/car_new.png';
                el.width = "50px";
                el.height = "50px";
                el.style['margin-left'] = "-25px";
                el.style['margin-top'] = "-25px";
                this.object.obj_icon_width = 50;
                this.object.obj_icon_height = 50;
            };
            return el;
        };

        return icon;
    }

    _getIconHeight(objectIconHeight) {
        if ((objectIconHeight != undefined) && (objectIconHeight != 0))
            return parseInt(objectIconHeight);
        else return 40;
    }

    _getIconWidth(objectIconWidth) {
        if ((objectIconWidth != undefined) && (objectIconWidth != 0))
            return parseInt(objectIconWidth);
        else return 20;
    }

    _getMarkerPosition(lat, lon) {
        if ((lat > 90) || (lat < -90)) {
            return new L.LatLng(0, 0);
        }
        else
            return new L.LatLng(lat, lon);
    }

    _getImageStatusMarkup(status) {
        return fmtools.getStatusObjectIcon(status);
    }

    _getIgnitionIcon(value) {
        return fmtools.getIgnitionIcon(value);
    }

    _onOverMarker(e) {
        e.target.setTooltipContent(e.target.labelMarkup.fullLabel);
    }

    _onOutMarker(e) {
        e.target.setTooltipContent(e.target.labelMarkup.standartLabel);
    }

    _onClickMarker(e) {
        let objectId = e.target.object.real_id;
        let event = new CustomEvent('tree:selectObject', { detail: { 'oid': objectId } });
        document.dispatchEvent(event);
        const mapEvent = new CustomEvent('map:objectSelected', { detail: { objectId: objectId } });
        document.dispatchEvent(mapEvent);
        this.httpService.getData('/objectinfo?oid=' + objectId)
            .then(
                data => {
                    this.initPopup(data);
                    this._showPopup();
                },
                error => { }
            );
    }

    initPopup(data) {
        this.popup = new MarkerPopup(this.object, data, this.getLatLng(), this.map);
    }

    _showPopup() {
        this.popup.show();
    }

    denyClick() {
        this.clickable = false;
    }

    setTooltip(borderColor) {
        if (this.tooltip) {
            try {
                this.unbindTooltip(this.tooltip);
            }
            catch (error) {
                this.clearEventListeners();
            }
        }

        var scale = this.scale;
        var offsetY = 25 * scale;

        if (this.map.options.showObjectIconDirection) {
            if (scale == 1) {
                scale = AlternativeScale1;
            }

            offsetY = AlternativeTooltipOffsetY * scale;
        }

        const tooltipProps = {
            permanent: true,
            interactive: true,
            direction: 'bottom',
            offset: new L.Point(-6, offsetY),
        };
        if (typeof borderColor == 'string') {
            tooltipProps.className = `tooltip-${borderColor}-border`;
        }

        let tooltip = L.tooltip(tooltipProps);
        tooltip.setContent(this.labelMarkup.standartLabel);
        tooltip.on('click', (event) => {
            !this.map.isClickBlocked() && this.clickable && this._onClickMarker(event);
        });
        this.bindTooltip(tooltip).openTooltip();
        this.tooltip = tooltip;
    }

    nameVisibilityCallback = () => {
        try {
            this.updateLabelMarkup();
        }
        catch (error) {
            console.error(error);
        }
    }

    routePaintedCallback = event => {
        if (event.detail.objectId != this.object.real_id) {
            return;
        }

        this.hasDefaultRoute = true;
        this.setTooltip(event.detail.color);
    }

    routeRemovedCallback = event => {
        if (event.detail.objectId != this.object.real_id) {
            return;
        }

        this.hasDefaultRoute = false;
        if (this.selected) {
            this.setTooltip('selected');
        }
        else {
            this.setTooltip();
        }
    }

    objectSelectedCallback = event => {
        if (event.detail.objectId != this.object.real_id) {
            if (!this.selected) {
                return;
            }

            this.selected = false;
            if (!this.hasDefaultRoute) {
                this.setTooltip();
            }
            return;
        }

        this.selected = true;
        if (!this.hasDefaultRoute) {
            this.setTooltip('selected');
        }
    }

    clearEventListeners() {
        document.removeEventListener('map:toggleObjectsNamesVisibility', this.nameVisibilityCallback);
        document.removeEventListener('map:newRoutePainted', this.routePaintedCallback);
        document.removeEventListener('map:routeRemoved', this.routeRemovedCallback);
        document.removeEventListener('map:objectSelected', this.objectSelectedCallback);
    }
}

export default FortMarker;
